// extracted by mini-css-extract-plugin
export default {"message-content":"classes_message-content__M8kI1"};